import { Grid } from "@mui/material";
import CardSys from "../cardSys";
import InputSearch from "../generic/inputSearch";

export default function FilterTableSys({handleFilter, ...props }) {

    return (
        <CardSys>
            <Grid container>
                <Grid item xs={12}>
                    <InputSearch {...props} onChange={({target}) => handleFilter(target.value)} handleClose={() => handleFilter("")}></InputSearch>
                </Grid>
            </Grid>
        </CardSys>
    )
}